import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingControl from '../../../components/LoadingControl';

import { pageLoaded } from '../../../utils';
import { ZRole } from '../../../generated';
import QaDashboardManagerScreen from './manager/QaDashboardManagerScreen';
import QaDashboardAgentScreen from './agent/QaDashboardAgentScreen'

class QaDashboardScreen extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        pageLoaded('QA: JibeIQ');
    }

    render() {
        const
            {
                currentUser,
            } = this.props;
        if (!currentUser) {
            return <LoadingControl />;
        }

        if (currentUser.RoleId == ZRole.Agent) {
            return <QaDashboardAgentScreen />
        }
        else {
            return <QaDashboardManagerScreen />
        }
    }
}

const select = state => ({ ...state.session });

export default connect(select)(QaDashboardScreen);